// FAR-55: ordering the Production Plan list.
//
// "Newest first by most recent activity", where activity is the later of the
// plan's Base Plan timestamp and its Modification timestamp. A plan whose
// modifications were saved today is more current than one on a newer Base Plan
// that nobody has touched.

// lastActivityAt(plan) -> the later of the two timestamps as a number, or null
// when the plan has neither (a pre-FAR-50 plan with no Base Plan).
export function lastActivityAt(plan) {
  const times = [plan?.modificationListCreatedAt, plan?.basePlanCreatedAt]
    .map((iso) => Date.parse(iso ?? ''))
    .filter((t) => !Number.isNaN(t))
  if (times.length === 0) {
    // Fall back to when the plan itself was created, so an undated plan still
    // lands somewhere sensible rather than always last.
    const created = Date.parse(plan?.createdAt ?? '')
    return Number.isNaN(created) ? null : created
  }
  return Math.max(...times)
}

// sortByRecentActivity returns a new array, newest first. Ties break on name
// so the order is stable rather than depending on what the API returned.
export function sortByRecentActivity(plans) {
  return [...(plans || [])].sort((a, b) => {
    const at = lastActivityAt(a)
    const bt = lastActivityAt(b)
    if (at === null && bt === null) return (a?.name || '').localeCompare(b?.name || '')
    if (at === null) return 1 // undated plans sort last
    if (bt === null) return -1
    if (at !== bt) return bt - at
    return (a?.name || '').localeCompare(b?.name || '')
  })
}

// hiddenCount is the N in "Show hidden (N)".
export function hiddenCount(plans) {
  return (plans || []).filter((p) => p?.hidden).length
}
